import { isShopifyEmbedded } from '@shopify/app-bridge/utilities';
import config from 'config';
import React from 'react';
import { useNavigate } from 'react-router';
import { postRequest } from 'utils/apiRequest';
import { getUrlForPath } from 'utils/functions';

export const UserAuthContext = React.createContext();


function inIframe () {
  try {
      return window.self !== window.top;
  } catch (e) {
      return true;
  }
}

export const logout = async () => {

  return postRequest('/logout').then(() => {
  }).finally(() => {

    let returnUrl = '?returnUrl='+(window.location.pathname.replace(config.defaultPath, ''));
    if(returnUrl.indexOf('/login') === -1 || returnUrl.indexOf('/register') === -1){
      returnUrl = '';
    }

    if(
      isShopifyApp()
      && localStorage.getItem('shopify_host') 
      && localStorage.getItem('shopify_shop') 
      && returnUrl !== ''){
        returnUrl += '?host='+localStorage.getItem('shopify_host')+'&shop='+localStorage.getItem('shopify_shop')
    }
    if(localStorage.getItem('user') !== null){
      localStorage.removeItem('user');
    }
    if(localStorage.getItem('token') !== null){
      localStorage.removeItem('token');
    }

    // localStorage.removeItem('shopify_shop');
    // localStorage.removeItem('shopify_host');
    localStorage.removeItem('shopify_session');
    localStorage.removeItem('is_shopify_app');

    window.location.href = getUrlForPath('/login')+returnUrl
  })
}

export const isShopifyApp = () => {
  let isShopify = localStorage.getItem('is_shopify_app');
  if(
    (
      isShopifyEmbedded() || (
        !isShopify 
        && inIframe() 
        && document.location.search.indexOf('hmac=') > -1
        && document.location.search.indexOf('session=') > -1
        && document.location.search.indexOf('shop=') > -1
      )
    ) || inIframe()
  ){
    localStorage.setItem('is_shopify_app', true);
    isShopify = true;
  }else if(!isShopify || !inIframe()){
    localStorage.removeItem('is_shopify_app');
    isShopify = false;
  }
  return isShopify
}

export const UserAuthProvider = (props) => {
  const [user, setUser] = React.useState({});

  const getUserFromStorage = () => {
    const userData = localStorage.getItem('user');
    if(userData){
      const userJSON = JSON.parse(userData);
      if(userJSON && userJSON.id){
        return userJSON;
      }
    }
    return {};
  }


  return (
    <UserAuthContext.Provider value={{
      user: user,
      isAdmin: () => {
        return getUserFromStorage().account_id < 3;
      },
      setUser: (usr) => {
        setUser(usr)
      },
      getUser: async () => {
        
        return await postRequest('/user').then((data) => {
          localStorage.setItem('user', JSON.stringify(data));
          setUser(data);
          return data;

        })
      },
      isLoggedIn: (shopifyToken = null) => {
        return new Promise(async (resolve, reject) => {
          const token = localStorage.getItem('token');
          if(token !== null){
            resolve(token);
          }else{
            // handle shopify
            if(isShopifyApp()){
              const searchParams = new URLSearchParams(window.location.search);
              const shop = searchParams.get('shop') ?? localStorage.getItem('shopify_shop');
              if(shop 
                && shopifyToken 
                && shopifyToken !== null 
                && shopifyToken !== 'null' 
                && shopifyToken !== ''
                ){
              sessionStorage.setItem('shopify_token', shopifyToken)

              const fd = new FormData();
              fd.append('source', 'shopify');
              fd.append('shop', shop);
              fd.append('access_token', shopifyToken);
              
              postRequest('/shopify/login', fd).then((data) => {

                if(data && data.authorization && data.authorization.token && data.user && data.user.id){

                  localStorage.setItem('token', data.authorization.token);
                  localStorage.setItem('user', JSON.stringify(data.user));

                  sessionStorage.removeItem('shopify_token')

                  if(data.user.subscription && !data.user.subscription.exists){
                    window.location.href = getUrlForPath('subscriptions');
                  }else{
                    window.location.href = getUrlForPath('/');
                  }
                  resolve(true)
                }else{
                  resolve(false);
                }
              })
            }else{
              resolve(token !== null);
            }
          }else{
            resolve(token !== null);
          }
          }
        });
      },

      getUserFromStorage: () => {
        return getUserFromStorage();
      },
      isShopifyApp: () => {
        return isShopifyApp();
      },
      hasSubscription: () => {
        const usr = getUserFromStorage();
        return usr && usr.subscription && usr.subscription.exists;
      },
      getSubscription: () => {
        const usr = getUserFromStorage();
        return usr && usr.subscription && usr.subscription;
      },
      getSubscriptionName: () => {
        const usr = getUserFromStorage();
        return usr && usr.subscription && usr.subscription.name;
      },
      getSubscriptionSource: () => {
        const usr = getUserFromStorage();
        return usr && usr.subscription && usr.subscription.source;
      },
      getSubscriptionAmount: () => {
        const usr = getUserFromStorage();
        return usr && usr.subscription && usr.subscription.amount;
      },
      getSubscriptionInterval: () => {
        const usr = getUserFromStorage();
        return usr && usr.subscription && usr.subscription.interval;
      },
      logout: async () => {
        return logout().then(() =>{
          setUser(null);
        });
      }
    }}>
      {props.children}
    </UserAuthContext.Provider>
  )
}
